import ReactCountryFlag from 'react-country-flag';
import type { ReactCountryFlagProps } from 'react-country-flag';

type CountryFlagProps = ReactCountryFlagProps & {
  /**
   * Accessible label for the flag image. Defaults to "<CODE> flag"
   * (e.g. "US flag") so every flag <img> has an alt attribute.
   */
  alt?: string;
};

/**
 * Wrapper around `react-country-flag` that guarantees an `alt` attribute
 * on the rendered flag <img>, fixing Lighthouse/PageSpeed accessibility
 * warnings ("Image elements do not have [alt] attributes").
 */
export function CountryFlag({ countryCode, alt, svg, ...props }: CountryFlagProps) {
  const altText = alt ?? (typeof countryCode === 'string' ? `${countryCode} flag` : '');

  // `alt` only applies to the svg <img> branch; the emoji branch renders a
  // <span role="img"> where an alt attribute would be invalid.
  return (
    <ReactCountryFlag countryCode={countryCode} svg={svg} alt={svg ? altText : undefined} {...props} />
  );
}

export default CountryFlag;
